import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import '@cloudscape-design/global-styles/index.css';
import { loadRuntimeConfig } from './api/config';

// Load runtime config (live vs mock) BEFORE importing modules that read it.
async function bootstrap() {
  await loadRuntimeConfig();

  // Seed the local representative datastore (used for analytics pages in both
  // modes, and for everything in mock mode).
  const { seedIfEmpty } = await import('./api/seed');
  seedIfEmpty();

  const [{ default: App }, { AuthProvider }] = await Promise.all([import('./App'), import('./auth/AuthProvider')]);

  ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <React.StrictMode>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </React.StrictMode>,
  );
}

void bootstrap();
